import { render, staticRenderFns } from "./Lois.vue?vue&type=template&id=04afb1fd&scoped=true&"
import script from "./Lois.vue?vue&type=script&lang=js&"
export * from "./Lois.vue?vue&type=script&lang=js&"
import style0 from "./Lois.vue?vue&type=style&index=0&id=04afb1fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04afb1fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
